import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { DockDailyOccupancyStateList, GescalesRawDataProgress } from 'src/swagger-gen/vnf-secured/models';
import { BaseService } from '../../../services/base.service';
import { AuthService } from '../../../tinea-components/okta/auth/auth.service';
@Injectable({
  providedIn: 'root',
})
export class VnfDashboardRepo extends BaseService {
  baseUrl = environment.apiUrl;
  basePublicUrl = environment.publicApiUrl;
  vnfDashboardUrl = this.baseUrl + '/custom/dock-occupancy';
  gescalesVnfDashboardUrl = this.baseUrl + '/custom/dock-occupancy/gescales';

  constructor(
    private http: HttpClient,
    private logger: NGXLogger,
    public authService: AuthService
  ) {
    super();
  }

  // getStationsList(
  //   offset?: number,
  //   limit?: number,
  //   params?: any[],
  // ): Observable<StationPagedList> {
  //   const url = this.stationUrl + '/search';
  //   let requestParams: any;
  //   let requestString = this.pagination(offset, limit, this.STATION_LIMIT);
  //   let queryParams = '';
  //   if (params) {
  //     params.forEach((p: any) => {
  //       queryParams += '&' + p.key + '=' + p.value;
  //     });
  //   }
  //   requestString += queryParams;
  //   requestParams = new HttpParams({ fromString: requestString });
  //   const httpOptions = {
  //     headers: new HttpHeaders({
  //       'Content-Type': 'application/json',
  //     }),
  //     params: requestParams,
  //   };
  //   return this.http.post<StationPagedList>(url, {}, httpOptions).pipe(
  //     tap((response) => {
  //       // this.logger.log(`Get stations List from backend`, response);
  //     }), // DEBUG
  //     catchError(this.handleServerError)
  //   );
  // }
  // getVnfDashboard(
  //   params?: any[],
  // ): Observable<DockDailyOccupancyStateList> {
  //   const url = this.gescalesVnfDashboardUrl;
  //   let requestParams: any;
  //   let requestString = '';
  //   let queryParams = '';
  //   if (params) {
  //     params.forEach((p: any) => {
  //       queryParams += '&' + p.key + '=' + p.value;
  //     });
  //   }
  //   requestParams = new HttpParams({ fromString: requestString });
  //   const httpOptions = {
  //     headers: new HttpHeaders({
  //       'Content-Type': 'application/json',
  //     }),
  //     params: requestParams,
  //   };
  //   return this.http.post<DockDailyOccupancyStateList>(url, {}, httpOptions).pipe(
  //     tap((response) => {
  //       // this.logger.log(`Get stations List from backend`, response);
  //     }), // DEBUG
  //     catchError(this.handleServerError)
  //   );
  // }
  getVnfDashboard(params: any[]): Observable<DockDailyOccupancyStateList> {
    const url = this.vnfDashboardUrl;
    return this.http.get<DockDailyOccupancyStateList>(url, {
      headers: this.httpHeaders(),
      params: params.reduce((acc, param) => {
        acc[param.key] = param.value;
        return acc;
      })
    },).pipe(
      catchError(this.handleServerError)
    );
  }

  //FAKE
  getVnfDashboard_FAKE(params: any[]): Observable<DockDailyOccupancyStateList> {
    // Données factices

const fakeData: DockDailyOccupancyStateList = [
  // 1. Les deux présents, un seul élément chacun
  {
    dockName: 'St Jean de Losne',
    dockUid: 'dock-001',
    gescalesDockName: 'SJDL – Quai National',
    hasAlarms: true,
    marineTrafficUrl: 'https://www.marinetraffic.com/en/ais/home/centerx:5.269/centery:47.102/zoom:15',
    gescalesOccupancies: [
      { gescalesBoatName: 'Emerald Liberté', start: '2025-06-25T12:13:33.256Z', end: '2025-06-25T12:13:33.256Z' }
    ],
    daisyOccupancies: [
      { boatName: 'Liberté Express', boatUid: 'boat-001', chargePointName: 'Borne Ouest', chargePointUid: 'charge-001', connection: '2025-06-25T12:13:33.256Z' }
    ]
  },
  // 2. gescalesOccupancies null, daisyOccupancies présent (un seul)
  {
    dockName: 'Port de Bordeaux',
    dockUid: 'dock-005',
    gescalesDockName: 'BDS – Quai Nord',
    hasAlarms: true,
    marineTrafficUrl: 'https://www.marinetraffic.com/en/ais/home/centerx:-0.55/centery:44.84/zoom:15',
    gescalesOccupancies: null,
    daisyOccupancies: [
      { boatName: 'Bordeaux Express', boatUid: 'boat-005', chargePointName: 'Borne Nord', chargePointUid: 'charge-005', connection: '2025-06-27T14:00:00.000Z' }
    ]
  },
  // 3. daisyOccupancies null, gescalesOccupancies présent (un seul)
  {
    dockName: 'Marseille Dock',
    dockUid: 'dock-003',
    gescalesDockName: 'MSL – Quai Sud',
    hasAlarms: true,
    marineTrafficUrl: 'https://www.marinetraffic.com/en/ais/home/centerx:5.37/centery:43.3/zoom:15',
    gescalesOccupancies: [
      { gescalesBoatName: 'Mediterranean Star', start: '2025-06-27T10:00:00.000Z', end: '2025-06-27T12:00:00.000Z' }
    ],
    daisyOccupancies: null
  },
  // 4. Les deux vides
  {
    dockName: 'Nantes Dock',
    dockUid: 'dock-004',
    gescalesDockName: 'NTS – Quai Ouest',
    hasAlarms: false,
    marineTrafficUrl: null,
    gescalesOccupancies: [],
    daisyOccupancies: []
  },
  // 5. Les deux présents, plusieurs éléments daisyOccupancies
  {
    dockName: 'Port de Lyon',
    dockUid: 'dock-002',
    gescalesDockName: 'PDL – Quai Central',
    hasAlarms: false,
    marineTrafficUrl: 'https://www.marinetraffic.com/en/ais/home/centerx:4.83/centery:45.75/zoom:15',
    gescalesOccupancies: [
      { gescalesBoatName: 'Lyon Express', start: '2025-06-26T08:00:00.000Z', end: '2025-06-26T10:00:00.000Z' }
    ],
    daisyOccupancies: [
      { boatName: 'Lyon River', boatUid: 'boat-002', chargePointName: 'Borne Est', chargePointUid: 'charge-002', connection: '2025-06-26T08:00:00.000Z' },
      { boatName: 'Lyon Star', boatUid: 'boat-003', chargePointName: 'Borne Sud', chargePointUid: 'charge-003', connection: '2025-06-26T09:00:00.000Z' }
    ]
  },
  // 6. Les deux présents, plusieurs éléments gescalesOccupancies
  {
    dockName: 'Port de Rouen',
    dockUid: 'dock-006',
    gescalesDockName: 'ROU – Quai Est',
    hasAlarms: true,
    marineTrafficUrl: 'https://www.marinetraffic.com/en/ais/home/centerx:1.1/centery:49.44/zoom:15',
    gescalesOccupancies: [
      { gescalesBoatName: 'Rouen Express', start: '2025-06-27T11:00:00.000Z', end: '2025-06-27T13:00:00.000Z' },
      { gescalesBoatName: 'Rouen Star', start: '2025-06-27T14:00:00.000Z', end: '2025-06-27T16:00:00.000Z' }
    ],
    daisyOccupancies: [
      { boatName: 'Rouen River', boatUid: 'boat-006', chargePointName: 'Borne Est', chargePointUid: 'charge-006', connection: '2025-06-27T11:30:00.000Z' }
    ]
  },
  // 7. gescalesOccupancies null, daisyOccupancies plusieurs éléments
  {
    dockName: 'Port de Strasbourg',
    dockUid: 'dock-007',
    gescalesDockName: 'STR – Quai Ouest',
    hasAlarms: false,
    marineTrafficUrl: 'https://www.marinetraffic.com/en/ais/home/centerx:7.74/centery:48.57/zoom:15',
    gescalesOccupancies: null,
    daisyOccupancies: [
      { boatName: 'Strasbourg Express', boatUid: 'boat-007', chargePointName: 'Borne Ouest', chargePointUid: 'charge-007', connection: '2025-06-27T09:00:00.000Z' },
      { boatName: 'Strasbourg River', boatUid: 'boat-008', chargePointName: 'Borne Nord', chargePointUid: 'charge-008', connection: '2025-06-27T10:00:00.000Z' }
    ]
  },
  // 8. daisyOccupancies null, gescalesOccupancies plusieurs éléments
  {
    dockName: 'Port de Dunkerque',
    dockUid: 'dock-008',
    gescalesDockName: 'DKQ – Quai Sud',
    hasAlarms: true,
    marineTrafficUrl: 'https://www.marinetraffic.com/en/ais/home/centerx:2.37/centery:51.04/zoom:15',
    gescalesOccupancies: [
      { gescalesBoatName: 'Dunkerque Express', start: '2025-06-27T12:00:00.000Z', end: '2025-06-27T14:00:00.000Z' },
      { gescalesBoatName: 'Dunkerque Star', start: '2025-06-27T15:00:00.000Z', end: '2025-06-27T17:00:00.000Z' }
    ],
    daisyOccupancies: null
  },
  // 9. Les deux présents, plusieurs éléments chacun
  {
    dockName: 'Port de Toulouse',
    dockUid: 'dock-009',
    gescalesDockName: 'TLS – Quai Central',
    hasAlarms: false,
    marineTrafficUrl: 'https://www.marinetraffic.com/en/ais/home/centerx:1.44/centery:43.6/zoom:15',
    gescalesOccupancies: [
      { gescalesBoatName: 'Toulouse Express', start: '2025-06-27T10:00:00.000Z', end: '2025-06-27T12:00:00.000Z' },
      { gescalesBoatName: 'Toulouse Star', start: '2025-06-27T13:00:00.000Z', end: '2025-06-27T15:00:00.000Z' }
    ],
    daisyOccupancies: [
      { boatName: 'Toulouse River', boatUid: 'boat-009', chargePointName: 'Borne Centrale', chargePointUid: 'charge-009', connection: '2025-06-27T10:30:00.000Z' },
      { boatName: 'Toulouse Light', boatUid: 'boat-010', chargePointName: 'Borne Sud', chargePointUid: 'charge-010', connection: '2025-06-27T13:30:00.000Z' }
    ]
  },
  // 10. Les deux présents, un élément chacun, hasAlarms false, marineTrafficUrl null
  {
    dockName: 'Port de Nice',
    dockUid: 'dock-010',
    gescalesDockName: 'NCE – Quai Est',
    hasAlarms: false,
    marineTrafficUrl: null,
    gescalesOccupancies: [
      { gescalesBoatName: 'Nice Express', start: '2025-06-27T11:00:00.000Z', end: '2025-06-27T13:00:00.000Z' }
    ],
    daisyOccupancies: [
      { boatName: 'Nice Star', boatUid: 'boat-011', chargePointName: 'Borne Est', chargePointUid: 'charge-011', connection: '2025-06-27T11:30:00.000Z' }
    ]
  }
];



    return of(fakeData).pipe(
      catchError(this.handleServerError)
    );
  }

  //   getGescalesRawDataProgress(
  //   params?: any[],
  // ): Observable<GescalesRawDataProgress> {
  //   const url = this.gescalesVnfDashboardUrl;
  //   const httpOptions = {
  //     headers: new HttpHeaders({
  //       'Content-Type': 'application/json',
  //     })
  //   };
  //   return this.http.get<GescalesRawDataProgress>(url, {}, ).pipe(
  //     tap((response) => {
  //       // this.logger.log(`Get stations List from backend`, response);
  //     }), // DEBUG
  //     catchError(this.handleServerError)
  //   );
  // }

  getGescalesRawDataProgress(): Observable<GescalesRawDataProgress> {
    const url = `${this.gescalesVnfDashboardUrl}/progress-state`;
    return this.http.get<GescalesRawDataProgress>(url, {
      headers: this.httpHeaders()
    }).pipe(
      catchError(this.handleServerError)
    );
  }
  // ********************************************************************************************

  importVnfDashboardDefinition(file: any): Observable<any> {
    const url = `${this.gescalesVnfDashboardUrl}/import`;

    const httpOptions: any = {
      headers: new HttpHeaders().set(
        'Content-Type',
        'application/vnd.ms-excel'
      ),
      observe: 'response'
    };

    return this.http.post<any>(url, file, httpOptions).pipe(
      catchError(this.handleServerError)
    );
  }
}
